import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import { Link } from "react-router-dom";
import Renubal from "../../../image/dashboard-4.png"
import Line from "../../../image/line.png";
import Creatable from "react-select/creatable";

const options = [
  { value: "2022", label: "2022"},
  { value: "2010", label: "2010"},
  { value: "2011", label: "2011"},
  { value: "2012", label: "2012"},
  { value: "2013", label: "2013"},
  { value: "2014", label: "2014"},
  { value: "2015", label: "2015"},
  { value: "2016", label: "2016"},
  { value: "2017", label: "2017"},
  { value: "2018", label: "2018"},
  { value: "2018", label: "2019"},
  { value: "2020", label: "2020"},
  { value: "2021", label: "2021"},
  { value: "2023", label: "2023"}
]

export class Dashboardfour extends Component {
  render() {
    return (
        <div className="container subdashboardmargindiv">
          <div className="row dashboard-four-padding-mainrow">
            <div className="col-8 dashboard-four-right-line">
              <div className="container">
                <div className="row">
                  <div className="col-6 dashboard-four-headline">
                    <p>Revanue Report</p>
                  </div>
                  <div className="col-3 dashboard-four-earning-sec">
                    <ul>
                      <li>Earning</li>
                    </ul>
                  </div>
                  <div className="col-3 dashboard-four-expense-sec">
                    <ul>
                      <li>Expense</li>
                    </ul>
                  </div>
                  <div className="col-12">
                  <img src={Renubal} alt="Not Found" className="dashboard-four-logo-sec" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="container">
                <div className="row">
                  <div className="col-12 dashboard-four-center">
                  <Creatable options={options} className="dashboard-four-year-option" defaultValue={options[0]} />
                  </div>
                  <div className="col-12 dashboard-four-center"><h3 className="dashboard-four-heading">$25,852</h3></div>
                  <div className="col-12 dashboard-four-center">
                    <span className="dashboard-four-heading-first">Budget : </span>
                    <span className="dashboard-four-headline-right">56,800</span>
                  </div>
                  <div className="col-12 dashboard-four-center">
                  <img src={Line} alt="Not Found" className="dashboard-four-line-logo-sec" />
                  </div>
                  <div className="col-12 dashboard-four-center">
                  <Link to="/increase-budget" className="UserManagementTDU">
                    <Button className="dashnoard-four-button" variant="success" size="sm" >Increase Budget</Button>
                  </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
  }
}

export default Dashboardfour ;